import Vue from "vue";
import App from "./App.vue";
import router from "./routes";
import store from "./store";
import "./assets/style/./reset.css";
import "./assets/style/global.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);


/* 全局指令:水波纹 */
import waves from "@/directive/waves/index.js";
Vue.directive("waves", waves);

// Vue.config.productionTip = false
new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
